import {
  ActivePayoutRequest,
  BalanceStackedData,
  StackedData,
  TOption,
} from '@src/types';

export const payoutRadioData: TOption[] = [
  { label: 'PA Payouts', value: 'rb_pa' },
  { label: 'Completion Payouts', value: 'rb_completion' },
];

export const payoutCheckboxData: TOption[] = [
  { label: 'Wire Transfer Forms', value: 'cb_wire_pdf' },
  { label: 'W9 Tax Forms', value: 'cb_w9' },
  { label: 'W-8BEN Tax Forms', value: 'cb_w8' },
];

export const tradeWithMicroAndMini: StackedData[] = [
  {
    date: '20 Aug 25',
    wining: 10,
    losing: -10,
    micro: 15,
    mini: 20,
    contracts: 5,
  },
  {
    date: '21 Aug 25',
    wining: 25,
    losing: -12,
    micro: 10,
    mini: 15,
    contracts: 10,
  },
  {
    date: '22 Aug 25',
    wining: 12,
    losing: -6,
    micro: 20,
    mini: 10,
    contracts: 15,
  },
  {
    date: '23 Aug 25',
    wining: 5,
    losing: -5,
    micro: 35,
    mini: 15,
    contracts: 20,
  },
  {
    date: '24 Aug 25',
    wining: 15,
    losing: -20,
    micro: 15,
    mini: 15,
    contracts: 17,
  },
  {
    date: '25 Aug 25',
    wining: 18,
    losing: -10,
    micro: 24,
    mini: 6,
    contracts: 30,
  },
  {
    date: '26 Aug 25',
    wining: 2,
    losing: -2,
    micro: 13,
    mini: 25,
    contracts: 5,
  },
  {
    date: '27 Aug 25',
    wining: 15,
    losing: -10,
    micro: 27,
    mini: 6,
    contracts: 10,
  },
];

export const mockBalanceData: BalanceStackedData[] = [
  {
    date: '20 Aug 25',
    account_balance: 10,
    net_pl: -10,
    other: 15,
  },
  {
    date: '21 Aug 25',
    account_balance: 25,
    net_pl: -12,
    other: 22,
  },
  {
    date: '22 Aug 25',
    account_balance: 12,
    net_pl: -6,
    other: 18,
  },
  {
    date: '23 Aug 25',
    account_balance: 5,
    net_pl: -5,
    other: 10,
  },
  {
    date: '24 Aug 25',
    account_balance: 15,
    net_pl: -20,
    other: 12,
  },
  {
    date: '25 Aug 25',
    account_balance: 18,
    net_pl: -10,
    other: 14,
  },
  {
    date: '26 Aug 25',
    account_balance: 2,
    net_pl: -2,
    other: 5,
  },
  {
    date: '27 Aug 25',
    account_balance: 15,
    net_pl: -10,
    other: 25,
  },
];

export const PayoutRequestData: ActivePayoutRequest[] = [
  {
    paymentNumber: 1,
    userId: 'LL983E833',
    userName: 'John Doe',
    accountId: 'PA-6613679868',
    accountCreatedAt: new Date().toISOString(),
    contracts: 8,
    launchAmount: '$50,000',
    tradingDays: 74,
    balance: '$56,169',
    balanceAt: new Date('2024-02-25').toISOString(),
    accountPayouts: '5',
    paid: '$35,745',
    payoutRatio: '90 / 10',
    amount: '$2,236',
    rithmicDeduction: '$ 4',
    rithmicDeductionAt: new Date('2024-11-30').toISOString(),
    method: 'Risework',
    note: `Requested by John Doe on Fri 29 Jan 2024@ 3:00 pm Elite Program | 90% PA - LL85685897 $54787 above threshold $2,763 PA-868`,
    currentStatus: 'Approved awaiting pay out ',
  },
  {
    paymentNumber: 2,
    userId: 'LL983E833',
    userName: 'John Doe',
    accountId: 'PA-6613679868',
    accountCreatedAt: new Date().toISOString(),
    contracts: 8,
    launchAmount: '$50,000',
    tradingDays: 74,
    balance: '$56,169',
    balanceAt: new Date('2024-02-25').toISOString(),
    accountPayouts: '5',
    paid: '$35,745',
    payoutRatio: '90 / 10',
    amount: '$2,236',
    rithmicDeduction: '$ 4',
    rithmicDeductionAt: new Date('2024-11-30').toISOString(),
    method: 'Risework',
    note: `Requested by John Doe on Fri 29 Jan 2024@ 3:00 pm Elite Program | 90% PA - LL85685897 $54787 above threshold $2,763 PA-868`,
    currentStatus: 'Approved awaiting pay out ',
  },
];
